import React, {Component} from 'react';
import { Row, Col, List, Avatar, Button, Icon } from 'antd';
import './PatentCard.css';
import jsondata from './data_patents.json';


// var mydata = JSON.parse(JSON.stringify(jsondata));
//  console.log(props.data);

class PatentCard extends Component {

  renderLoading() {
    return <div>Loading...</div>;
  }

  renderPickCardData(cardPick,pick) {
    // console.log(pick);
    // var pick = 'Medical-Device2';
    var cardData = cardPick.filter((x,i)=> x.id===pick);
    // console.log(cardData[0]);
    if (this.cardData==='undefined') { 
      return this.renderLoading();
    } else {
      return this.renderCard(cardData[0]);
    }
  }

  renderCard(cardData){
    return (
      <div className="PatentCard--container" id={cardData.title} name={cardData.title}>
        <div className="PatentCard--headline">
          {/* <Icon type="solution" style={{marginRight:15}}/>   */}
          {cardData.headline}
        </div>
        <Row>
          <Col md={8} style={{float:'left'}}>
          <div className="PatentCard--image">
            <a href={cardData.pdf_url}>
              <img className="PatentCard--img-main img-responsive img-rounded" alt="patent" src={cardData.img_url} />
            </a>
          </div>
          <div className="PatentCard--img-extra">
            <a href={cardData.pdf_url}>
              <Button size="large"><Icon type="file-pdf" /> Download Patent PDF</Button>
            </a>
          </div>
          </Col>
          <Col md={16} >
            <div className="PatentCard--description">
              <div className="PatentCard--subheadline">
              {cardData.subheadline}
              </div>
              <div className="PatentCard--body-text">
                <p>
                {cardData.description1}
                </p>

                <List
                  itemLayout="horizontal"
                  dataSource={cardData.subarticle}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar icon="solution" />}
                        title={<span className="PatentCard--list-item-headline">{item.title}</span>}
                        description={item.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            </div>            
          </Col>
        </Row> 
        <Row>
          <Col md={24}>         
          <p style={{padding:20}}>
            {cardData.description2}
          </p>
          </Col>
        </Row>

      </div>
    )
  }
  
  render(){

    if (!this.props.pick) { 
      return this.renderLoading();
    } else if (this.props.pick){
      return this.renderPickCardData(jsondata,this.props.pick);
    }

  
  }
}

 export default PatentCard;


// WEBPACK FOOTER //
// ./src/common/Cards/PatentCard/PatentCard.js